
import Vue from 'vue';
import CheckboxInput from '@shared/components/CheckboxInput.vue';
export default Vue.extend({
  name: 'stepone',
  components: {
    CheckboxInput,
  },
  data() {
    return {
      power: false,
      fiber: false,
      other: false,
    };
  },
  watch: {
    power(val) {
      if (val) {
        this.fiber = false;
        this.other = false;
      }
    },
    fiber(val) {
      if (val) {
        this.power = false;
        this.other = false;
      }
    },
    other(val) {
      if (val) {
        this.fiber = false;
        this.power = false;
      }
    },
  },
  methods: {
    navigateMinSide(): void {
      // @ts-ignore
      this.$gtm.trackEvent({
        event: 'minside_hkraft',
        category: 'Flytteskjema',
        action: 'B2C',
        label: 'Kundeservice Flytteskjema',
        customerType: 'B2C',
      });
      window.location.href =
        'https://minside.hkraft.no?utm_source=Flyttemelding&utm_medium=Klikk%20fra%20skjema&utm_campaign=HK-sporing&utm_content=Min%20side';
    },
    navigateAltibox(): void {
      // @ts-ignore
      this.$gtm.trackEvent({
        event: 'minside_altibox',
        category: 'Flytteskjema',
        action: 'B2C',
        label: 'Kundeservice Flytteskjema',
        customerType: 'B2C',
      });
      window.location.href = 'https://www.altibox.no/minesider';
    },
    navigateNext(): void {
      this.$emit('next');
    },
  },
});
